import { useAuth } from "../../login/state/useAuth";
import { User } from "../data";

export const useLoggedInUserInfo = () => {
  const { authState } = useAuth();
  const { user } = authState;

  return user || ({} as User);
};
